
import { useEffect, useState } from 'react'
import { Route, Redirect } from 'react-router-dom'
import useAuth from '../hooks/useAuth'

export default function ProtectedRoute({children, ...rest}) {
    const {isLoggedIn, user} = useAuth()
    const [loggedIn, setLoggedIn] = useState(true)

    useEffect(() => {
        if (!isLoggedIn() ) {
            setLoggedIn(false)
        } else {
            setLoggedIn(true)
        }
    }, [user, isLoggedIn])

    return (
        <Route
          {...rest}
          render={({ location }) =>
            loggedIn ? (
              children
            ) : (
              <Redirect
                to={{
                  pathname: "/login",
                  state: { from: location }
                }}
              />
            )
          }
        />
      );
}